import { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Btn, H3 } from "../../../../../AbstractElements";
import { Close, FullScreenModal, Save } from "../../../../../Constant";
import UXDesigner from "./UXDesigner";
import WebDesign from "./WebDesign";

const FullModal = () => {
  const [fullScreen, setFullScreen] = useState(false);
  const fullScreenToggle = () => setFullScreen(!fullScreen);

  return (
    <>
      <Btn color="secondary-2x" outline type="button" onClick={fullScreenToggle}>{FullScreenModal}</Btn>
      <Modal fullscreen fade isOpen={fullScreen} toggle={fullScreenToggle}>
        <ModalHeader toggle={fullScreenToggle}>
          <H3 className="modal-title">Fullscreen modal</H3>
        </ModalHeader>
        <ModalBody>
          <WebDesign />
          <UXDesigner />
        </ModalBody>
        <ModalFooter>
          <Btn color="secondary" onClick={fullScreenToggle}>{Close}</Btn>
          <Btn color="primary">{Save}</Btn>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default FullModal;
